module.exports = __webpack_public_path__ + "img/goodcase02.df7917b8.png";